import { useRouter } from "next/router";
import React, { FC, ReactNode, useEffect } from "react";

import { useCurrentAccount } from "src/entities/account/useCurrentAccount";

const trackUrl = (url: string) => {
  const pageEvent = {
    event: "pageview",
    page: url,
  };

  if (window.dataLayer) {
    window.dataLayer.push(pageEvent);
  }
};

const useTrackUrl = () => {
  const router = useRouter();

  useEffect(() => {
    router.events.on("routeChangeComplete", trackUrl);

    return () => {
      router.events.off("routeChangeComplete", trackUrl);
    };
  }, [router.events]);
};

const useGtmUserTracking = () => {
  const { currentAccount } = useCurrentAccount();

  const mainPatientId = currentAccount?.patients.find((p) => p.mainUser)?.id;

  useEffect(() => {
    if (!!window.dataLayer) {
      window.dataLayer.push({
        logged_in: !!mainPatientId,
        user_id: mainPatientId ?? null,
      });
    }
  }, [mainPatientId]);
};

export const GtmProvider: FC<{ children: ReactNode }> = ({ children }) => {
  useTrackUrl();
  useGtmUserTracking();

  return <>{children}</>;
};

declare const window: Window["window"] & {
  dataLayer: object[] | undefined;
};
